module.exports = __webpack_public_path__ + "img/showcase-rent-banner.eff8487b.jpg";